import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { GenericModalComponent } from "../../generic-modal/generic-modal.component";
import { ButtonIcons } from "../../action-button/models/button-icons.enum";

@Component({
	selector: 'site-note-photos',
	templateUrl: './site-note-photos.component.html',
	styleUrls: ['./site-note-photos.component.scss', '../../stylesheets/job-actions.scss', '../../stylesheets/job-main.scss', '../../stylesheets/job-inputs.scss']
})
export class SiteNotePhotosComponent implements OnInit, OnDestroy {
	private _isVisible = false;
	public files = [];
	public readonly ButtonIcons = ButtonIcons;
	public isAnyPhotoExceedMaxSize = false;
	@Output() public close = new EventEmitter<{ files: any[], isVisible: boolean, isAnyPhotoExceedMaxSize: boolean }>();
	@ViewChild(GenericModalComponent) public addPhotosModal: GenericModalComponent;
	@Input() public set isVisible(value: boolean) {
		this._isVisible = value;
		if (this.addPhotosModal) {
			this._isVisible ? this.addPhotosModal.open() : this.addPhotosModal.hide();
		}
	}
	public get isVisible() {
		return this._isVisible;
	}

	constructor() {

	}

	ngOnInit(): void {

	}

	onClose(): void {
		this.close.emit({ isVisible: false, files: this.files, isAnyPhotoExceedMaxSize: this.isAnyPhotoExceedMaxSize });
	}

	public onClickAddPhoto(input): void {
		input.click();
	}

	public onDeletePhoto(photo): void {
		this.files = this.files.filter(x => x.localId !== photo.localId);
	}

	public onChangePhotos(files: any[], fileInput): void {
		const filesToUpload = Object.values(files);

		//photo size max 10MB 
		const maxAllowedSize = 10 * 1024 * 1024;

		let lastId = this.files.length ? Math.max(...this.files.map(f => f.localId)) : 0;
		lastId++;

		filesToUpload.forEach((f, i) => {
			f.localId = lastId + i;
			if (f.size > maxAllowedSize) {
				this.isAnyPhotoExceedMaxSize = true;
			}

			const reader = new FileReader();

			reader.onloadend = () => {
				f.thumbnail = reader.result;
				this.files.push(f);
			}
			reader.readAsDataURL(f);
		})

		fileInput.value = '';
	}

	ngOnDestroy(): void {

	}
}